export const CImageSectionBreakFragments = {
  field: `
    fragment imageSectionBreak on imageSectionBreak_MatrixField {
      ... on imageSectionBreak_block_Entry {
        id
        typeHandle
        idName
        desktopImage {
          url @transform(mode: "crop", width: 2000 immediately: true)
          title
          hasFocalPoint
          focalPoint
        }
        mobileImage {
          url @transform(mode: "crop", width: 640, immediately: true)
          title
          hasFocalPoint
          focalPoint
        }
      }
    }
    `,
}
